/**
* Copyright Zendesk, Inc.
*
* Use of this source code is governed under the Apache License, Version 2.0
* found at http://www.apache.org/licenses/LICENSE-2.0.
*/
import styled, { css } from 'styled-components';
import React, { Children } from 'react';
import { retrieveComponentStyles, DEFAULT_THEME } from '@zendeskgarden/react-theming';

const COMPONENT_ID = 'typography.icon';
const sizeStyles = props => {
  const margin = props.isStart && `${props.theme.space.base * 2}px`;
  const size = props.theme.iconSizes.md;
  return css(["margin-", ":", ";width:", ";height:", ";"], props.theme.rtl ? 'left' : 'right', margin, size, size);
};
const StyledIcon = styled(_ref => {
  let {
    children,
    isStart,
    ...props
  } = _ref;
  return React.cloneElement(Children.only(children), props);
}).attrs({
  'data-garden-id': COMPONENT_ID,
  'data-garden-version': '8.76.9'
}).withConfig({
  displayName: "StyledIcon",
  componentId: "sc-10rfb5b-0"
})(["position:relative;top:-1px;vertical-align:middle;", ";", ";"], props => sizeStyles(props), props => retrieveComponentStyles(COMPONENT_ID, props));
StyledIcon.defaultProps = {
  theme: DEFAULT_THEME
};

export { StyledIcon };
